import { AnalyticsIdentifyEvent, AnalyticsGroupEvent } from '.cache/__types__';
import { Analytics, AnalyticsUser, ExposureTrackEvent, PageEvent, TrackEvent } from './types';
import { getCookieConsentForCategory } from '@modules/cookie-utils';

export class ComposeAnalytics implements Analytics {
  constructor(private destinations: Analytics[]) {
    this.initialize();
  }

  async initialize(): Promise<void> {
    if (!getCookieConsentForCategory('analytics')) {
      return;
    }

    await Promise.all(this.destinations.map((d) => d.initialize()));
  }

  track(e: Partial<TrackEvent | ExposureTrackEvent>): void {
    this.destinations.map((d) => d.track(e));
  }
  page(e: Partial<PageEvent>): void {
    this.destinations.map((d) => d.page(e));
  }
  identify(e: Partial<AnalyticsIdentifyEvent>): void {
    this.destinations.map((d) => d.identify(e));
  }
  group(e: Partial<AnalyticsGroupEvent>): void {
    this.destinations.map((d) => d.group(e));
  }
  user(): AnalyticsUser | undefined {
    const users = this.destinations.map((d) => d.user()).filter(Boolean);
    return users.length ? users[0] : undefined;
  }
  reset(): void {
    this.destinations.map((d) => d.reset());
  }
}
